import {
  BookedWorkCell,
  type LedgerCollapse,
  type LedgerColumn,
} from '@billda/design-system';

/**
 * Column and collapse definitions for the org-wide variations ledger. Screens
 * own these; the shared layer only reads them.
 */

/** CSS container the variations list declares, so the collapse point tracks
 * the list width rather than the viewport (the side panel changes one, not
 * the other). */
export const VARIATIONS_LEDGER_CONTAINER = 'variations-ledger';

/** Same point as activity: this list carries the same four columns. */
export const VARIATIONS_COLLAPSE: LedgerCollapse = {
  container: VARIATIONS_LEDGER_CONTAINER,
  at: 620,
};

/** Site names truncate in the Site / Plot cell; the plot number never does. */
export const VARIATIONS_COLUMNS: LedgerColumn[] = [
  { key: BookedWorkCell.Ref, label: 'Ref', flex: 0.8, hideBelow: 900 },
  { key: BookedWorkCell.SitePlot, label: 'Site / Plot', flex: 1.9 },
  {
    key: BookedWorkCell.BookedBy,
    label: 'Booked by',
    flex: 1.1,
    hideBelow: 820,
  },
  { key: BookedWorkCell.When, label: 'When', flex: 1 },
];
